export default "__VITE_ASSET__0e0d9ad2__"